const VhTypes = {
  DEFAULT: 'default',
  MEDICAL: 'medical',
  BRANCHING: 'branching',
  FREEFORM_V3: 'freeform_v3',
};

export default VhTypes;
